import { AxiosResponse } from "axios";
import { ENDPOINTS } from "../../../../processes/api/endpoints";
import { Base3DApi } from "../Base3DApi";
import { IDataGLBRenderObject, IRenderGLBResponse } from "./type";

export class GLBApi extends Base3DApi {
  public async renderGLB(
    data: IDataGLBRenderObject
  ): Promise<AxiosResponse<IRenderGLBResponse>> {
    return this.axiosInstance.post(ENDPOINTS.GLB.renderGLB, data);
  }
}
